<template lang="pug">
.question-list
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/service_question") {{ $t('Service Questions')}}
    li.active
      span {{ $t('Service Questions List') }}

  .row.margin-top
    .col-sm-6
      //form
      div
        .form-inline
          .input-group
              input.form-control(type="text", placeholder="タイトル", v-model="searchTitle", v-on:keydown.enter="search(false)")
              .input-group-btn
                button.btn.btn-default(v-on:click="search(false)")
                  i.fa.fa-search
    .col-sm-6.text-right
      a.btn.btn-info(v-on:click="goQuestionNew()")
          i.fa.fa-plus
          span {{ $t('New Registration') }}
  div
    div(v-if="searchEnd && questions.length > 0")
      .row.margin-top
        //- 一覧表示
        .table-responsive
          table.table.table-condensed()
            //- 表示ヘッダ
            thead
              tr.info
                th.col-sm-4 評価タイトル
                th.col-sm-3 状態
                th.col-sm-3 評価開始日
                th.col-sm-2
            tbody
              tr(v-for="(question,index) in questions")
                td {{ question.attributes.title }}
                td
                td
                td(style="text-align: right;")
                  a(v-on:click="goQuestionEdit(question.id, question.attributes['is-before-notification-start'])").btn.btn-info.btn-sm.margin-right {{ $t('Edit') }}
                  a(v-on:click="questionDelete(question.id, question.attributes['is-use-user-type'])").btn.btn-danger.btn-sm {{ $t('Delete') }}

      //- 更に読み込む
      .row.margin-top(v-if="nextExist")
        .col-xs-12.text-center
          button.btn.btn-default.next-page-search-btn(v-on:click="search(true)")
            i.fa.fa-chevron-down
            =" "
            span {{ $t('Read More') }}

    .row.margin-top(v-if="searchEnd && questions.length == 0")
      .col-xs-12
        .alert.alert-warning
          i.fa.fa-exclamation-triangle
          =" "
          span {{ $t('No Data') }}

</template>
<script>
var utils = require('../utils')
import AppHeader from './AppHeader'

export default {
  name: 'service-question-list',
  created () {
    if (!this.isSystemManagement && !this.isHumanStaff) {
      this.$router.push({ path: '/' })
    }
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      questions: '',
      searchTitle: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (addSearch) {
      let data = {
        search_title: this.searchTitle
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }
      this.$store.dispatch('GET_SERVICE_QUESTION_LIST', { data: data })
      .then(res => {
        if (addSearch) {
          this.questions = this.questions.concat(res.questions.data)
        } else {
          this.questions = res.questions.data
          this.searchEnd = true
        }
        this.nextExist = res.next_exist
      })
      .catch(err => console.log(err))
    },
    goQuestionNew: function () {
      this.$router.push({ path: '/service_question/questions/new' })
    },
    goQuestionEdit: function (questionId, isBeforeNotificationStart) {
      if (isBeforeNotificationStart === 1) {
        window.alert('この評価は未公開の接客評価の評価項目に設定されています。\n編集を行うと評価項目が変わります。')
      }
      this.$router.push({ path: '/service_question/questions/' + questionId + '/edit' })
    },
    questionDelete: function (questionId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('SERVICE_QUESTION_DELETE', {
          data: {
            id: questionId
          }
        })
        .then(res => {
          this.search(false)
        })
        .catch(err => console.log(err))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ServiceQuestionList.vue?1c6fc1d0